import React, { useEffect, useState } from "react";
import PathwayStyle from "./pathway.module.css";
import http from "../../../utils/http";
import GenomeList from "../../../assets/json/Genomes/pathwoay_genomename";
import {ReactComponent as DownLoadIcon} from '../../../assets/icon/云下载.svg'
import axios from "axios";
import { Button, Input, Pagination, Select, Table } from "antd";
const { Search } = Input;

function Pathway() {
  const [selectedGenome, setSelectedGenome] = useState(GenomeList[0]?.value); // 设置默认选中的第一个选项
  const [SearchVal,setSearchVal]=useState('')
const [page,setPage]=useState(1);
const [total,setTotal]=useState(0);
const [PathwayData,setPathwayData]=useState([]);
  useEffect(() => {
    getTableData()
  }, [selectedGenome,page,SearchVal]);
const getTableData=()=>{
  http
  .get(`/api/genome/pathway/?species=${selectedGenome}&page=${page}&gene_info=${SearchVal}`)
  .then((res) => {
    setTotal(res.count)
    setPathwayData(res.results)
  })
  .catch((err) => {});
}
  const colums = [
    {
      key: "1",
      title: "Gene ID",
      dataIndex: "gene_id",
      align: "center",
    },
    {
      key: "2",
      title: "Gene Name",
      dataIndex: "gene_name",
      align: "center",
    },
    {
      key: "3",
      title: "KO ID",
      dataIndex: "gene_KO_ID",
      align: "center",
      render:(index,item)=>{
        return <a href={item.gene_KO_link} target="_blank">{index}</a>
      }
    },
    {
      key: "4",
      title: "KO Name",
      dataIndex: "gene_KO_name",
      align: "center",
    },
    {
      key: "5",
      title: "Pathway",
      dataIndex: "gene_Pathway",
      align: "center",
    },
  ];
const downloadaxios=()=>{

  axios({
    url: `/api/genome/pathway/?species=${selectedGenome}&page=${page}&gene_info=${SearchVal}&export=1`,
    method: 'GET',
    responseType: 'blob',  // 重要：告诉服务器返回的是文件流
  })
    .then((response) => {
      // 获取响应头中的 Content-Disposition
      const contentDisposition = response.headers['content-disposition'];
  
      // 从 Content-Disposition 中提取文件名
      const filename = contentDisposition
        ? contentDisposition.split('filename=')[1].replace(/"/g, '')  // 去掉引号
        : 'default-filename.ext';  // 如果没有文件名，提供一个默认值
  
      // 创建下载链接
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // 使用从响应头中提取的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch(error => {
      console.error('Download error:', error);
    });
}
  const handleSelectChange = (value) => {
    setSelectedGenome(value);
    console.log("Selected genome: ", value);
  };

  return (
    <div className={PathwayStyle.Pathway_app}>
      <div className={PathwayStyle.Pathway_Header}>
        <p>Genome/Pathway</p>
      </div>
      <div className={PathwayStyle.Pathway_Content}>
        <Select
          options={GenomeList}
          defaultValue={selectedGenome} // 设置默认选中的值
          onChange={handleSelectChange} // 设置选中的值变化时的回调
          style={{ width: 200, margin: "10px 0" }}
        />
        <div className={PathwayStyle.Pathway_Content_form}>
          <Search
            placeholder="input search text"
            onSearch={(value) =>setSearchVal(value)}
            style={{ width: 200 }}
          />
        <Button
        style={{display:"flex",alignItems:"center",justifyContent:"center",border:"none"}}
        onClick={downloadaxios}
        >
          <DownLoadIcon  />
        </Button>
        </div>
        <Table
          style={{ width: "100%", margin: "10px 0" }}
          bordered={true}
          columns={colums}
          dataSource={PathwayData}
          pagination={false}
        />
         <div style={{ width: "95%", height: "50px", margin: "auto" }}>
        <Pagination
          total={total}
          onChange={(page) => {
            setPage(page);
          }}
          showSizeChanger={false}
          showQuickJumper={true}
          style={{
            width: "100%",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        />
      </div>
      </div>
    </div>
  );
}

export default Pathway;
